import { AuthorizedInstallersContext } from '@authorizedInstaller/contexts/AuthorizedInstallersContext';
import { FormControlCheckbox } from '@components/utility/checkboxes';
import { FormControl, Typography } from '@mui/material';
import { useContext } from 'react';

const TermsStep = () => {
    const {
        formik: { values, touched, errors, setFieldValue, handleBlur },
    } = useContext(AuthorizedInstallersContext);

    return (
        <div className="flex flex-col gap-4">
            <FormControl>
                <FormControlCheckbox
                    labelProps={{ label: 'I have read and accept the terms & agreements' }}
                    checked={values.accept_terms ?? false}
                    onChange={(e) => setFieldValue('accept_terms', e.target.checked)}
                    onBlur={handleBlur}
                />
                {touched.accept_terms && Boolean(errors.accept_terms) ? (
                    <Typography variant="caption" color={'error.main'}>
                        {errors.accept_terms}
                    </Typography>
                ) : null}
            </FormControl>
        </div>
    );
};

export { TermsStep };
